import { CURRENT_LANG } from '@/helpers/lang'

export const formatNumberDisplayByLang = (
  value: number | string,
  options?: Intl.NumberFormatOptions
) => {
  const numberValue = typeof value === 'string' ? Number(value.replace(/[\s,]/g, '')) : value
  return new Intl.NumberFormat(CURRENT_LANG, options).format(numberValue)
}

export const formatStatusCardNumber = (cardNumber: string) => {
  return cardNumber.replace(/(\w{6})(\w{1})(\w{8})(\w{1})/g, '$1 $2 $3 $4')
}

export const capitalize = (inputString: string) =>
  inputString.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase())

// Todo: Unit test to write
export const upperFirst = (inputString: string) => {
  return inputString ? inputString.charAt(0).toUpperCase() + inputString.slice(1) : ''
}
